exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vpd-input-group .vpd-clear-btn[data-v-989a4b80]{line-height:26px;width:26px}.vpd-input-group .vpd-clear-btn[data-v-989a4b80]:hover{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-989a4b80","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/ReportSelectDocument/ReportSelectDocument.vue
// module id = 646
// module chunks = 0